
import purchaseTable from '../../../../components/reimbursement/purchaseTable'
import publicBuill from '../../../../components/reimbursement/js/publicBuill'
import axios from 'axios'
export default {
  name: 'purchase',
  components: {
    purchaseTable
  },
  data() {
    return {
      failedShow: true,
      passedShow: true,
      queryDatas: {
        rq: [],
        dJh: '',
        jkr: '',
        zt: '',
        startTime: '',
        endTime: '',
        settleMode: ''
      },
      state: '',
      /* 左边树结构 */
      data: [{
        label: '全部',
        children: []
      }],
      billValue: '',
      roles: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },

      /* 右边 */
      activeName: 'first',
      purchaseTable: [],
      /* 分页 */
      pageConfig: {
        currentPage: 1,
        total: 0,
        size: 50,
        jeArr: []
      },
      sumArr: []
    }
  },
  created() {
    publicBuill.setThis(this)
    this.data[0].children = publicBuill.getBillTreeDb('cg')
    this.roles = publicBuill.getTreeValue(this.data[0].children)
    this.billValue = this.roles
    const obj = {}
    obj.label = '全部'
    obj.value = this.billValue
    this.data[0].children.unshift(obj)
    this.findPage()
  },
  methods: {
    /* 点击树 */
    handleNodeClick(val) {
      this.billValue = val.value ? val.value : this.roles
      this.findPage()
    },
    tabsClick(tab, event) {
      //请求状态：1：未归档 2：已归档.
      this.state = ''
      this.passedShow = true
      this.failedShow = true
      if (tab.index === '1') { // 未归档
        this.state = '1'
        this.passedShow = false
      } else if (tab.index === '2') { // 已归档
        this.state = '2'
        this.failedShow = false
      }
      // 请求数据
      this.findPage()
    },
    findPage() {
      if (!this.billValue) {
        this.$message.error('该用户缺少数据查看权限！！')
        return
      }
      const data = {
        djh: this.queryDatas.djh ? this.queryDatas.djh : null,
        gys: this.queryDatas.jkr ? this.queryDatas.jkr : null,
        documentType: this.billValue,
        shr: localStorage.getItem('userName'),
        lrrcode: localStorage.getItem('userNo'),
        limit: this.pageConfig.size,
        currentPage: this.pageConfig.currentPage,
        state: this.state,
        zt: this.queryDatas.zt,
        settleMode: this.queryDatas.settleMode
      }
      const loading = this.$loading({
        lock: true,
        text: '查询中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$post('/fesback/statistics/purchased.z', data).then(res => {
        if (res.data) {
          const failed = res.data.failed.toFixed(2)
          const passed = res.data.passed.toFixed(2)
          const paid = res.data.paid.toFixed(2)
          this.pageConfig.jeArr = [publicBuill.formatAmount(failed), publicBuill.formatAmount(passed), publicBuill.formatAmount(paid)]
          const paymentJe = publicBuill.formatAmount(res.data.paymentJe.toFixed(2))
          const approvedJe = publicBuill.formatAmount(res.data.approvedJe.toFixed(2))
          this.sumArr = ['', '合计', '', '', '', '', paymentJe, approvedJe]
        }
      })
      /* 获取所有已办流程 */
      this.$post('/fesback/purchase/getDoneItems.z', data).then(response => {
        publicBuill.purchaseBillData(response.data.data)
        this.purchaseTable = response.data.data
        this.pageConfig.total = response.data.count
        loading.close()
      }).catch(function(error) {
        loading.close()
        this.$message.error('系统异常：' + error)
      })
    },
    /* 分页 */
    handleSizeChange(val) { // 每页多少条
      this.pageConfig.size = val
      this.findPage()
    },
    handleCurrentChange(val) { // 当前页
      this.pageConfig.currentPage = val
      this.findPage()
    },
    queryData(val) {
      this.billValue = val.billValue
      this.queryDatas = val
      this.findPage()
    },
    exportybcg(value) {
      this.billValue = value.billValue
      this.queryDatas = value
      const loading = this.$loading({
        lock: true,
        text: '请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        djh: this.queryDatas.djh ? this.queryDatas.djh : null,
        gys: this.queryDatas.jkr ? this.queryDatas.jkr : null,
        documentType: this.billValue,
        shr: localStorage.getItem('userName'),
        lrrcode: localStorage.getItem('userNo'),
        limit: this.pageConfig.size,
        currentPage: this.pageConfig.currentPage,
        state: this.state,
        zt: this.queryDatas.zt,
        settleMode: this.queryDatas.settleMode
      }
      axios.post(
        '/fesback/purchase/exportPurchaseTable.z',
        data,
        {
          responseType: 'blob'
        }
      ).then(res => {
        loading.close()
        let fileName = ''
        if (data.state === '') {
          fileName = '已办采购付款单' + '.xlsx'
        } else if (data.state === '1') {
          fileName = '已办采购付款单未归档单据' + '.xlsx'
        } else if (data.state === '2') {
          fileName = '已办采购付款单已归档单据' + '.xlsx'
        }
        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        const a = document.createElement('a')
        const href = URL.createObjectURL(blob)
        a.href = href
        a.setAttribute('download', fileName)
        a.click()
        URL.revokeObjectURL(href)
      })
    }
  }

}
